module.exports = __webpack_public_path__ + "fonts/31E180_0_0.b1e2b2d.woff2";